import { useSelect } from '../../util';
export function useSelectHotel(sideEffects) {
    return useSelect(sideEffects);
}
